import { useLazyQuery } from "@apollo/client";

import { GET_NODE_BY_ID } from "../../../common/operations/queries";
import { errorNotification } from "../../../common/variables/notification";
import type {
  GetNodeByIdQuery,
  GetNodeByIdQueryVariables,
} from "./../../../API";

export const useGetNodeById = () => {
  const [getNodes, { data, loading }] = useLazyQuery<
    GetNodeByIdQuery,
    GetNodeByIdQueryVariables
  >(GET_NODE_BY_ID, {
    fetchPolicy: "network-only",
  });

  const fetchNode = (nodeId: string): void => {
    if (!nodeId) return;

    const normalizedNodeId = nodeId.startsWith("C_")
      ? nodeId.replace("C_", "C#").replace("_L_", "#L#").replace("_N_", "#N#")
      : nodeId;

    getNodes({
      variables: {
        nodeId: normalizedNodeId,
      },
    }).catch((): void => {
      errorNotification();
    });
  };

  return { data: data?.getNodeById, fetchNode, loading };
};
